<template>
  <div>
    <div class="input-container">
      <b-row>
        <b-col>
          <label class="input-title">Role</label>
          <b-form-select v-model="roleSelected" :options="roleOptions"></b-form-select>
        </b-col>
      </b-row>
    </div>
    <hr>
    <b-button class="main-input-button" block @click="changeCollaboratorRole">Change role</b-button>
  </div>
</template>

<script>
  import {db} from "../../../main";

  export default {
    name: "ChangeCollaboratorRole.vue",
    data() {
      return {
        toDoListId: null,
        collaboratorId: null,
        collaboratorInformation: {},
        roleSelected: 'Administrator',
        roleOptions: [
          {value: 'Administrator', text: 'Administrator'},
          {value: 'Member', text: 'Member'}
        ]
      }
    },
    methods: {
      changeCollaboratorRole() {
        db
          .collection('users/' + this.collaboratorId + '/user_collaborative_to_do_list_participation')
          .where('collaborativeToDoListId', '==', this.toDoListId)
          .get()
          .then(querySnapshot => {
            querySnapshot.docs.map(doc => {
              db
                .collection('users/' + this.collaboratorId + '/user_collaborative_to_do_list_participation')
                .doc(doc.id)
                .update('collaborativeToDoListRole', this.roleSelected)
                .then(() => {
                  this.hideModal('collaborator-option-modal')
                })
            })
          })
      },

      hideModal(id) {
        this.$root.$emit('bv::hide::modal', id)
      }
    },
    mounted() {
      this.toDoListId = this.$route.params.collaborativeListId
      this.collaboratorId = this.$route.params.collaboratorId

      // retrieve the user role information
      db
        .collection('users/' + this.collaboratorId + '/user_collaborative_to_do_list_participation')
        .where('collaborativeToDoListId', '==', this.toDoListId)
        .get()
        .then(querySnapshot => {
          const userCollaborativeToDoListParticipatedObject = querySnapshot.docs.map(doc => doc.data())
          this.collaboratorInformation = userCollaborativeToDoListParticipatedObject[0]
          this.roleSelected = this.collaboratorInformation.collaborativeToDoListRole
        })
    }
  }
</script>

<style scoped>
  .input-container {
    margin-bottom: 1em;
  }

  .input-title {
    font-weight: bold;
  }

  .main-input-button {
    font-weight: bold;
    background-color: #212441;
    padding: 0.5em;
  }

  .main-input-button:hover {
    font-weight: bold;
    background-color: #FFFFFF;
    color: #212441;
    padding: 0.5em;
  }
</style>
